class Path {
    constructor() {
        this.segments = [];
    }
    addPoint(point) {
        this.segments.push(point);
    }
    drawPath(context) {
        context.beginPath();
        let _first = true;
        this.segments.forEach(point => {
            if (_first) {
                context.moveTo(point.x, point.y);
                _first = false;
            }
            else {
                context.lineTo(point.x, point.y);
            }
        });
    }
}
export default Path;
//# sourceMappingURL=path.js.map